import {Component} from "@angular/core";
import {ModalService} from "../../../shared/modal/modal.service";

@Component({
  templateUrl: './invitedetails.modal.template.html'
})

export class InviteDetailsModalComponent extends ModalService implements IModalService {
}
